import { render, staticRenderFns } from "./ReferralSelectorModal.vue?vue&type=template&id=72289562&scoped=true&"
import script from "./ReferralSelectorModal.vue?vue&type=script&lang=js&"
export * from "./ReferralSelectorModal.vue?vue&type=script&lang=js&"
import style0 from "./ReferralSelectorModal.vue?vue&type=style&index=0&id=72289562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72289562",
  null
  
)

export default component.exports